import 'dragscroll'
import { picoapp } from 'picoapp'

import header from '@/components/header.js'
import language from '@/components/language.js'
import usp from '@/components/usp.js'
import accountLogin from '@/components/accountLogin.js'
import recommendedProducts from '@/components/recommended-products.js'
import cartValidation from '@/components/cart-validation.js'
import hero from '@/components/hero.js'
import footer from '@/components/footer.js'
import mobileNavigation from '@/components/mobile-navigation.js'
import cartDrawerItem from '@/components/cart-drawer-item.js'
import cartDrawer from '@/components/cart-drawer.js'
import cartTemplate from '@/components/cart-template.js'
import cartNote from '@/components/cart-note.js'
import sizeguide from '@/components/sizeguide.js'
import blog from '@/components/blog.js'
import customerLogin from '@/components/customer-login.js'
import customerAddressForm from '@/components/customer-address-form.js'
import customerAddresses from '@/components/customer-addresses.js'
import search from '@/components/search.js'
import accountAddresses from '@/components/account-addresses.js'
import product from '@/components/product.js'
import productCarousel from '@/components/product-carousel.js'
import productTabs from '@/components/product-tabs.js'
import productTabAnchors from '@/components/product-tab-anchors.js'
import productUpsell from '@/components/product-upsell.js'
import productVariants from '@/components/product-variants.js'
import linkedDrawer from '@/components/linked-drawer.js'
import featuredCollectionsList from '@/components/featured-collections-list.js'
import featuredCollection from '@/components/featured-collection.js'
import newsletter from '@/components/newsletter.js'
import productCondition from './components/product-condition'
import infinitePagination from './components/infinite-pagination'
import filter from './components/filter'
import rangeSlider from './components/range-slider'
import collectionFilterDrawer from './components/collection-filter-drawer'
import gwpProgress from './components/gwp-progress'
import gwpDrawer from './components/gwp-drawer'
import collectionSort from './components/collection-sort'
import linkedProducts from './components/linked-products'
import cartDrawerUpsell from './components/cart-drawer-upsell'
import geoPopup from './components/geo-popup'

const state = {
    cartOpen: false,
    filterOpen: false,
}

const components = {
    header,
    language,
    usp,
    accountLogin,
    product,
    productCondition,
    recommendedProducts,
    cartValidation,
    hero,
    productCarousel,
    footer,
    mobileNavigation,
    collectionFilterDrawer,
    filter,
    rangeSlider,
    cartDrawerUpsell,
    cartDrawerItem,
    cartDrawer,
    cartTemplate,
    cartNote,
    sizeguide,
    blog,
    customerLogin,
    customerAddressForm,
    customerAddresses,
    accountAddresses,
    search,
    productTabs,
    productTabAnchors,
    productUpsell,
    productVariants,
    featuredCollectionsList,
    featuredCollection,
    linkedDrawer,
    newsletter,
    infinitePagination,
    gwpProgress,
    gwpDrawer,
    collectionSort,
    linkedProducts,
    geoPopup
}

export default picoapp(components, state)
